module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-flag-b-52827085296452ca1f57e36a566d146b.svg";